import { render } from "./PolicyOnboardComponent.vue?vue&type=template&id=4de4e68a"
import script from "./PolicyOnboardComponent.vue?vue&type=script&lang=js"
export * from "./PolicyOnboardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__